<app-map-toolbox-wrapper [isOpen]="isOpen">
    <h4 class="c-toolbox-header">{{label}}</h4>
    <ng-content></ng-content>
</app-map-toolbox-wrapper>
